import React, { useState, useEffect } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { dataService } from '@/lib/dataService'

export const TeacherProfile: React.FC = () => {
  const { user } = useAuth()
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [deptId, setDeptId] = useState('1')
  const [phone, setPhone] = useState('')
  const [teacherCard, setTeacherCard] = useState('')
  const [departments, setDepartments] = useState<any[]>([])
  const [msg, setMsg] = useState<{ type: 'success' | 'error'; text: string } | null>(null)

  useEffect(() => {
    const loadDepts = async () => {
      const d = await dataService.getDepartments()
      setDepartments(d)
    }
    loadDepts()
    if (user) {
      setFirstName(user.first_name || '')
      setLastName(user.last_name || '')
      setEmail(user.email || '')
      setUsername(user.username || '')
      setDeptId(user.department_id ? String(user.department_id) : '1')
      setPhone(user.phone || '')
      setTeacherCard(user.teacher_card || '')
    }
  }, [user])

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    setMsg(null)

    if (password && password !== confirmPassword) {
      setMsg({ type: 'error', text: '❌ รหัสผ่านใหม่และการยืนยันรหัสผ่านไม่ตรงกัน' })
      return
    }

    try {
      const updateFields: any = {
        email,
        username,
        phone,
        teacher_card: teacherCard
      }
      if (password) {
        updateFields.password = password
      }

      await dataService.updateTeacherProfile(
        user.id,
        firstName,
        lastName,
        Number(deptId),
        updateFields
      )
      setMsg({ type: 'success', text: '💾 บันทึกข้อมูลส่วนตัวครูผู้สอนเรียบร้อยแล้ว' })
    } catch (err: any) {
      setMsg({ type: 'error', text: err.message || 'เกิดข้อผิดพลาดในการบันทึก' })
    }
  }

  return (
    <div style={{ maxWidth: '720px', margin: '0 auto' }} className="glassmorphism-container">
      <div className="glassmorphism" style={{ padding: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '8px' }}>👤 ข้อมูลส่วนตัวคุณครู</h2>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '24px', fontSize: '14px' }}>
          แก้ไขโปรไฟล์ประจำตัวของคุณ ชื่อผู้ใช้ อีเมล รหัสผ่าน และข้อมูลการติดต่ออื่น ๆ
        </p>

        {msg && (
          <div style={{
            background: msg.type === 'success' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
            border: `1px solid ${msg.type === 'success' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`,
            borderRadius: '8px',
            padding: '16px',
            color: msg.type === 'success' ? 'var(--success)' : 'var(--danger)',
            fontSize: '14px',
            marginBottom: '20px'
          }}>
            {msg.text}
          </div>
        )}

        <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          <div className="grid-responsive-2">
            <div>
              <label className="input-label" htmlFor="teacherFirstNameInput">ชื่อจริง</label>
              <input 
                id="teacherFirstNameInput"
                type="text" 
                className="input-field" 
                value={firstName} 
                onChange={(e) => setFirstName(e.target.value)} 
                required 
              />
            </div>
            <div>
              <label className="input-label" htmlFor="teacherLastNameInput">นามสกุล</label>
              <input 
                id="teacherLastNameInput"
                type="text" 
                className="input-field" 
                value={lastName} 
                onChange={(e) => setLastName(e.target.value)} 
                required 
              />
            </div>
          </div>

          <div className="grid-responsive-2">
            <div>
              <label className="input-label" htmlFor="teacherUsernameInput">ชื่อผู้ใช้ (Username)</label>
              <input 
                id="teacherUsernameInput"
                type="text" 
                className="input-field" 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                required 
              />
            </div>
            <div>
              <label className="input-label" htmlFor="teacherEmailInput">อีเมลหลัก (Email)</label>
              <input 
                id="teacherEmailInput"
                type="email" 
                className="input-field" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
              />
            </div>
          </div>

          <div className="grid-responsive-2">
            <div>
              <label className="input-label" htmlFor="teacherCardInput">รหัสประจำตัวครู / รหัสบุคลากร</label>
              <input 
                id="teacherCardInput"
                type="text" 
                placeholder="เช่น T1004"
                className="input-field" 
                value={teacherCard} 
                onChange={(e) => setTeacherCard(e.target.value)} 
              />
            </div>
            <div>
              <label className="input-label" htmlFor="teacherPhoneInput">เบอร์โทรศัพท์มือถือ</label>
              <input 
                id="teacherPhoneInput"
                type="tel" 
                placeholder="เช่น 089-XXXXXXX"
                className="input-field" 
                value={phone} 
                onChange={(e) => setPhone(e.target.value)} 
              />
            </div>
          </div>

          <div>
            <label className="input-label" htmlFor="teacherDeptSelect">สังกัดกลุ่มสาระ</label>
            <select 
              id="teacherDeptSelect"
              className="input-field" 
              value={deptId} 
              onChange={(e) => setDeptId(e.target.value)}
              style={{ background: 'var(--bg-input)' }}
            >
              {departments.map(d => (
                <option key={d.id} value={d.id}>{d.name}</option>
              ))}
            </select>
          </div>

          <div style={{ borderTop: '1px solid var(--border)', paddingTop: '20px', marginTop: '10px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>🔒 เปลี่ยนรหัสผ่านใหม่ (หากต้องการ)</h3>
            <div className="grid-responsive-2">
              <div>
                <label className="input-label" htmlFor="teacherPasswordInput">รหัสผ่านใหม่</label>
                <input 
                  id="teacherPasswordInput"
                  type="password" 
                  placeholder="ว่างไว้หากไม่ต้องการเปลี่ยน"
                  className="input-field" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                />
              </div>
              <div>
                <label className="input-label" htmlFor="teacherConfirmPasswordInput">ยืนยันรหัสผ่านใหม่</label>
                <input 
                  id="teacherConfirmPasswordInput"
                  type="password" 
                  placeholder="กรอกรหัสผ่านใหม่อีกครั้ง"
                  className="input-field" 
                  value={confirmPassword} 
                  onChange={(e) => setConfirmPassword(e.target.value)} 
                />
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
            <button type="submit" className="btn btn-primary" style={{ padding: '10px 24px' }}>💾 บันทึกการแก้ไข</button>
          </div>
        </form>
      </div>
    </div>
  )
}
export default TeacherProfile
